import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";
import Button from "../../components/atoms/Button";
import StepProgress from "../../components/molecules/StepProgress";
import PhoneInput from "react-phone-number-input";

export default function PersonalInformationAdmin() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const emailFromParams = searchParams.get("email") || "";

    const [fullName, setFullName] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [email, setEmail] = useState(emailFromParams); // ⬅ initial sesuai param
    const [phoneCode, setPhoneCode] = useState("+62");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [photo, setPhoto] = useState<string | null>(null);

    const handleUploadPhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setPhoto(reader.result as string);
            reader.readAsDataURL(file);
        }
    };

    const handleNext = () => {
        const currentLang = location.pathname.startsWith("/id") ? "id" : "en";
        navigate(
            `/${currentLang}/login/admin/company-information?email=${encodeURIComponent(email)}`
        );
    };

    const steps = [
        { number: 1, title: "Confirmation" },
        { number: 2, title: "Personal Information" },
        { number: 3, title: "Company Information" },
    ];

    const lang = location.pathname.startsWith("/id") ? "id" : "en";

    return (
        <MainLayoutDetail>
            <div className="container-section mx-auto mt-32 px-6">
                <SectionBox background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)">
                    <div className="mb-10 flex justify-center">
                        <StepProgress steps={steps} currentStep={2} />
                    </div>
                    <div className="bg-white p-4 rounded-2xl shadow-md max-w-4xl mx-auto mt-6">
                        <h2 className="text-center text-2xl font-semibold text-gray-800 mb-8">
                            Personal Information
                        </h2>

                        <div className="flex justify-center mb-6">
                            <label className="relative cursor-pointer group">
                                <div className="w-32 h-32 rounded-full border shadow overflow-hidden bg-white">
                                    <img
                                        src={photo || "https://placehold.co/400x400"}
                                        alt="User Avatar"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center text-white text-sm rounded-full transition">
                                    Change Photo
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={handleUploadPhoto}
                                />
                            </label>
                        </div>

                        <div className="grid md:grid-cols-2 gap-5">
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Nama Lengkap" : "Full Name"}</label>
                            <input
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                placeholder="Full Name"
                                className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                            />

                            </div>
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Judul Pekerjaan" : "Job Title"}</label>
                            <input
                                value={jobTitle}
                                onChange={(e) => setJobTitle(e.target.value)}
                                placeholder="Job Title"
                                className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                            />

                            </div>
                        </div>
                        <div className="grid md:grid-cols-1 gap-5 mt-5">
                            <div className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Email" : "Email"}</label>
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email Address"
                                type="email"
                                className="border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                            />

                            </div>
                            <div  className="flex flex-col">
                            <label className="text-sm font-medium">{lang === "id" ? "Nomor Telepon" : "Phone Number"}</label>
                            <PhoneInput
                                defaultCountry="ID"
                                international
                                withCountryCallingCode
                                value={phoneNumber}
                                onChange={(value) => setPhoneNumber(value ?? "")}
                                className="w-full border rounded-lg pl-3 pr-1 py-1 flex flex-col md:flex-row gap-4"
                            />

                            </div>

                        </div>

                        <div className="flex justify-between mt-10">
                            <Button onClick={() => navigate(-1)} className="px-10 !bg-gray-400 hover:bg-gray-500">
                                Back
                            </Button>
                            <Button onClick={handleNext} className="px-10 bg-primary hover:bg-secondary">
                                Next
                            </Button>
                        </div>
                    </div>
                </SectionBox>
            </div>
        </MainLayoutDetail>
    );
}
